import { TransformationRuleDTO } from "./transformationRuleDTO";

export class TransformationProtocolDTO {

    public id!: number;
    public inputFieldReferences!: string; //comma separated list like "<ref1>,<ref2>,.....". use FieldDefinition name attribute as references. if no reference is set a new outputfield needs to be created with no input field.
    public outputFieldIndex!: number;
    public outputFieldName!: string;
    public outputFieldLength!: number;
    public transformationRules!: TransformationRuleDTO[];
    public isOutputParameter!: boolean;
    public startNewRecord!: boolean;
    public groupingLevel!: number;

    constructor(){
        this.transformationRules = new Array();
    }
}